import React from "react";
import { useSelector } from "react-redux";

import { selectHeatMapMetric } from "../../store/heatmap/HeatMapSelectors";
import HeatMapMetricSelect, {
  isHeatMapMetricDateReliant,
} from "./HeatMapMetricSelect";
import HeatMapDateRangePicker from "./HeatMapDateRangePicker";
import HeatMapColorGradient from "./HeatMapColorGradient";
import HeatMapAdditionalOptions from "./HeatMapAdditionalOptions";
import { StyledConfigPane } from "./HeatMapModalStyles";

/**
 * Left pane of the Data Visualization modal — four sections:
 * Metric, Date range (conditional), Customize gradient, Additional
 * options.
 *
 * The date range picker is shown only for date-reliant metrics.
 * Inventory (the only non-date-reliant heat map metric) is sourced from
 * product catalog data and doesn't carry a time dimension.
 */
const HeatMapConfigPanel: React.FC = () => {
  const metric = useSelector(selectHeatMapMetric);
  const isDateReliant = isHeatMapMetricDateReliant(metric);

  return (
    <StyledConfigPane>
      <HeatMapMetricSelect />
      {isDateReliant && <HeatMapDateRangePicker />}
      <HeatMapColorGradient />
      <HeatMapAdditionalOptions />
    </StyledConfigPane>
  );
};

export default HeatMapConfigPanel;
